module.exports = __webpack_public_path__ + "img/poster-4.25e5fd56.jpg";